// import loyaltyGift from '../loyalty/gift';
// import validateGWP from '../loyalty/validate-gwp';
import stickySummary from './sticky-summary';
import signatureRequest from './signature-request';
import StickyButtonsMobile from './sticky-buttons-mobile';
import CartPageDiscount from '../../components/cart-discount/cart-page-discount';

export default () => {
  // Remove the GWP if user is logged out
  // validateGWP();

  if (!$('.cart-section').length) {
    return;
  }

  // loyaltyGift();
  signatureRequest();
  stickySummary();
  new StickyButtonsMobile();
  new CartPageDiscount();
};
